import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";
const serverErrorsRegex = new RegExp(
  `500 Internal Server Error|401 Unauthorized|403 Forbidden|404 Not Found|502 Bad Gateway|503 Service Unavailable`,
  "mi"
);
if (environment.production) {
  Sentry.init({
    dsn: environment.sentryDSN,
    release: "ezpin-vj@" + environment.version,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [environment.projectUrl],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    tracesSampleRate: environment.sentrySampleRate,
    ignoreErrors: [
      serverErrorsRegex,
      // Random plugins/extensions
      "top.GLOBALS",
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      "originalCreateNotification",
      "canvas.contentDocument",
      "MyApp_RemoveAllHighlights",
      "http://tt.epicplay.com",
      "Can't find variable: ZiteReader",
      "jigsaw is not defined",
      "ComboSearch is not defined",
      "http://loading.retry.widdit.com/",
      "atomicFindClose",
      // Facebook borked
      "fb_xd_fragment",
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      "bmi_SafeAddOnload",
      "EBCallBackMessageReceived",
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      "conduitPage",
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      /login/i,
    ],
    beforeSend(event, hint) {
      /* tslint:disable:no-string-literal only-arrow-functions */
    
      // Safely read exception value
      const exceptionValue =
        event?.exception?.values?.[0]?.value ?? '';
    
      let isNonErrorException =
        typeof exceptionValue === 'string' &&
        exceptionValue.startsWith('Non-Error exception captured');
    
      // Safely read original exception message
      const message =
        hint?.originalException &&
        typeof hint.originalException === 'object'
          ? hint.originalException.message
          : undefined;
    
      let chunkError =
        typeof message === 'string' &&
        message.startsWith('Uncaught (in promise): ChunkLoadError');
    
      // Merge conditions safely
      if (typeof message === 'string') {
        isNonErrorException =
          isNonErrorException ||
          message.startsWith('Non-Error exception captured') ||
          chunkError;
      }
    
      /* tslint:enable:no-string-literal only-arrow-functions */
    
      // Handle chunk load error
      if (chunkError) {
        if (confirm('New version available. Load New Version?')) {
          window.location.reload();
        }
        return null; // prevent sending to Sentry
      }
    
      // Ignore noisy non-error exceptions
      if (isNonErrorException) {
        return null;
      }
    
      return event;
    },
  });
}

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
